import { TripViewModel } from '@wegoTypes/flights/tripViewModel';

interface BaggageInfo {
  pieces?: number;
  weight?: number;
  type: 'checked' | 'cabin';
}

export const MOCK_BAGGAGE_INFO: BaggageInfo[] = [
  {
    type: 'checked',
    pieces: 2,
    weight: 7,
  },
  {
    type: 'cabin',
    pieces: 2,
  },
];

export const mockTripViewModel: TripViewModel = {
  fares: [
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0',
        price: {
          totalAmount: 282,
          totalAmountWithFraction: 282.0,
          totalAmountUsd: 217.96895,
          amount: 141,
          amountWithFraction: 141.0,
          amountUsd: 108.984474,
          originalAmount: 141.03714,
          originalAmountUsd: 108.984474,
          amountPerAdult: 141.03714,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'jazeeraairways.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=jazeeraairways.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.329678,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 722.0155,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'jazeeraairways.com',
        name: 'jazeeraairways.com',
        type: 'airline',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6',
        price: {
          totalAmount: 297,
          totalAmountWithFraction: 297.0,
          totalAmountUsd: 229.72,
          amount: 149,
          amountWithFraction: 149.0,
          amountUsd: 114.86,
          originalAmount: 148.64067,
          originalAmountUsd: 114.86,
          amountPerAdult: 148.64067,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'onetravel.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=onetravel.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.415387,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 716.14,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'onetravel.com',
        name: 'onetravel.com',
        type: 'ota',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
  ],
  filteredFares: [
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0',
        price: {
          totalAmount: 282,
          totalAmountWithFraction: 282.0,
          totalAmountUsd: 217.96895,
          amount: 141,
          amountWithFraction: 141.0,
          amountUsd: 108.984474,
          originalAmount: 141.03714,
          originalAmountUsd: 108.984474,
          amountPerAdult: 141.03714,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'jazeeraairways.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=jazeeraairways.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.329678,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 722.0155,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'jazeeraairways.com',
        name: 'jazeeraairways.com',
        type: 'airline',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6',
        price: {
          totalAmount: 297,
          totalAmountWithFraction: 297.0,
          totalAmountUsd: 229.72,
          amount: 149,
          amountWithFraction: 149.0,
          amountUsd: 114.86,
          originalAmount: 148.64067,
          originalAmountUsd: 114.86,
          amountPerAdult: 148.64067,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'onetravel.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=onetravel.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.415387,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 716.14,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'onetravel.com',
        name: 'onetravel.com',
        type: 'ota',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
  ],
  legs: [
    {
      airlines: [
        {
          name: 'Jazeera Airways',
          code: 'J9',
        },
      ],
      arrivalAirport: {
        name: 'Cairo Airport',
        code: 'CAI',
        cityCode: 'CAI',
      },
      departureAirport: {
        name: 'Dubai International Airport',
        code: 'DXB',
        cityCode: 'DXB',
      },
      leg: {
        arrivalDate: '2024-10-31',
        departureDate: '2024-10-31',
        id: 'DXB-CAI:J9124~31:J9733~31:0',
        departureTime: '16:45',
        arrivalTime: '22:30',
        duration: '06h 45m',
        departureAirportCode: 'DXB',
        arrivalAirportCode: 'CAI',
        airlineCodes: ['J9'],
        stopoverAirportCodes: ['KWI'],
        allianceCodes: [''],
        stopoversCount: 1,
        departureTimeMinutes: 1005,
        arrivalTimeMinutes: 1350,
        departureDateTime: '2024-10-31T16:45:00.000+04:00',
        arrivalDateTime: '2024-10-31T22:30:00.000+03:00',
        stopoverDurationMinutes: 120,
        durationMinutes: 405,
        overnight: false,
        stopoverDuration: '02h',
        durationDays: 0,
        longStopover: false,
        segments: [
          {
            durationMinutes: 105,
            stopoverDurationMinutes: 120,
            departureAirportCode: 'DXB',
            arrivalAirportCode: 'KWI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9124',
            departureDateTime: '2024-10-31T16:45:00.000+04:00',
            arrivalDateTime: '2024-10-31T17:30:00.000+03:00',
            arrivalAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            departureAirport: {
              name: 'Dubai International Airport',
              code: 'DXB',
              cityCode: 'DXB',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
            operatingAirlineCode: '',
          },
          {
            durationMinutes: 180,
            stopoverDurationMinutes: 0,
            departureAirportCode: 'KWI',
            arrivalAirportCode: 'CAI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9733',
            departureDateTime: '2024-10-31T19:30:00.000+03:00',
            arrivalDateTime: '2024-10-31T22:30:00.000+03:00',
            arrivalAirport: {
              name: 'Cairo Airport',
              code: 'CAI',
              cityCode: 'CAI',
            },
            departureAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
            operatingAirlineCode: '',
          },
        ],
        operatingAirlineCodes: [],
        stopoverCode: 'ONE_STOP',
        shortStopover: false,
        earlyDeparture: false,
        lateArrival: false,
        newAircraft: false,
        oldAircraft: true,
        highlyRatedCarrier: false,
        score: 831,
        stops: [
          {
            code: 'ONE_STOP',
            price: {
              totalAmount: 738,
              totalAmountWithFraction: 738.0,
              totalAmountUsd: 738.2,
              amount: 738,
              amountWithFraction: 738.0,
              amountUsd: 738.2,
              originalAmount: 738.2,
              originalAmountUsd: 738.2,
              amountPerAdult: 738.2,
              amountPerChild: 0,
              amountPerInfant: 0,
              taxAmount: 347.2,
              taxAmountUsd: 347.2,
              totalTaxAmount: 347.2,
              totalTaxAmountUsd: 347.2,
              currencyCode: 'USD',
              paymentFeeAmountUsd: 0,
              bookingFee: 0,
              bookingFeeUsd: 0,
              totalBookingFee: 0,
              totalBookingFeeUsd: 0,
            },
          },
        ],
      },
      segmentViewModels: [
        {
          segment: {
            operatingAirlineCode: '',
            durationMinutes: 105,
            stopoverDurationMinutes: 120,
            departureAirportCode: 'DXB',
            arrivalAirportCode: 'KWI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9124',
            departureDateTime: '2024-10-31T16:45:00.000+04:00',
            arrivalDateTime: '2024-10-31T17:30:00.000+03:00',
            arrivalAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            departureAirport: {
              name: 'Dubai International Airport',
              code: 'DXB',
              cityCode: 'DXB',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
          },
          pointStartPercentage: 25.925925925925924,
          pointWidthPercentage: 29.629629629629626,
        },
      ],
    },
  ],
  tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
  normalizedFlight: false,
  tripCardTags: ['best', 'cheapest'],
};

export const mockSponsoredTripViewModel: TripViewModel = {
  fares: [
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0',
        price: {
          totalAmount: 282,
          totalAmountWithFraction: 282.0,
          totalAmountUsd: 217.96895,
          amount: 141,
          amountWithFraction: 141.0,
          amountUsd: 108.984474,
          originalAmount: 141.03714,
          originalAmountUsd: 108.984474,
          amountPerAdult: 141.03714,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'jazeeraairways.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=jazeeraairways.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.329678,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 722.0155,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'jazeeraairways.com',
        name: 'jazeeraairways.com',
        type: 'airline',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6',
        price: {
          totalAmount: 297,
          totalAmountWithFraction: 297.0,
          totalAmountUsd: 229.72,
          amount: 149,
          amountWithFraction: 149.0,
          amountUsd: 114.86,
          originalAmount: 148.64067,
          originalAmountUsd: 114.86,
          amountPerAdult: 148.64067,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'onetravel.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=onetravel.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.415387,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 716.14,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'onetravel.com',
        name: 'onetravel.com',
        type: 'ota',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
  ],
  filteredFares: [
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0',
        price: {
          totalAmount: 282,
          totalAmountWithFraction: 282.0,
          totalAmountUsd: 217.96895,
          amount: 141,
          amountWithFraction: 141.0,
          amountUsd: 108.984474,
          originalAmount: 141.03714,
          originalAmountUsd: 108.984474,
          amountPerAdult: 141.03714,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'jazeeraairways.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:jazeeraairways.com:e6e273f441d1a6c0&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=jazeeraairways.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.329678,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 722.0155,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'jazeeraairways.com',
        name: 'jazeeraairways.com',
        type: 'airline',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
    {
      fare: {
        paymentFees: [
          {
            paymentMethodId: 3,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 10,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
          {
            paymentMethodId: 15,
            currencyCode: 'SGD',
            amount: 0,
            amountUsd: 0,
            totalAmount: 0,
            totalAmountUsd: 0,
          },
        ],
        id: '2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6',
        price: {
          totalAmount: 297,
          totalAmountWithFraction: 297.0,
          totalAmountUsd: 229.72,
          amount: 149,
          amountWithFraction: 149.0,
          amountUsd: 114.86,
          originalAmount: 148.64067,
          originalAmountUsd: 114.86,
          amountPerAdult: 148.64067,
          amountPerChild: 0,
          amountPerInfant: 0,
          taxAmount: 0,
          taxAmountUsd: 0,
          totalTaxAmount: 0,
          totalTaxAmountUsd: 0,
          currencyCode: 'SGD',
          paymentFeeAmountUsd: 0,
          bookingFee: 0,
          bookingFeeUsd: 0,
          totalBookingFee: 0,
          totalBookingFeeUsd: 0,
        },
        providerCode: 'onetravel.com',
        handoffUrl:
          'https://handoff.wegostaging.com/flights/continue?currency=SGD&url_locale=en&site_code=SG&device_type=desktop&app_type=WEB_APP&domain=www.wego.com.sg&fare_id=2de43e388d3fdfb2msr:onetravel.com:4d542d897ef5fea6&route=DXB-CAI&search_id=2de43e388d3fdfb2msr&trip_id=cDXB:cCAI:2024-10-31&pwa=false&api_version=2&integration_code=onetravel.com&region=us-east-1&placement_type=metasearch',
        ecpc: 0.415387,
        remainingSeatsCount: 0,
        conditionIds: [],
        legConditionIds: [],
        refundable: false,
        exchangeable: false,
        tags: [],
        score: 716.14,
        legsSourceTypes: ['NORMAL'],

        tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
      },
      provider: {
        code: 'onetravel.com',
        name: 'onetravel.com',
        type: 'ota',
        instant: false,
        facilitatedBooking: false,
        wegoFare: false,
      },
    },
  ],
  legs: [
    {
      airlines: [
        {
          name: 'Jazeera Airways',
          code: 'J9',
        },
      ],
      arrivalAirport: {
        name: 'Cairo Airport',
        code: 'CAI',
        cityCode: 'CAI',
      },
      departureAirport: {
        name: 'Dubai International Airport',
        code: 'DXB',
        cityCode: 'DXB',
      },
      leg: {
        arrivalDate: '2024-10-31',
        departureDate: '2024-10-31',
        id: 'DXB-CAI:J9124~31:J9733~31:0',
        departureTime: '16:45',
        arrivalTime: '22:30',
        duration: '06h 45m',
        departureAirportCode: 'DXB',
        arrivalAirportCode: 'CAI',
        airlineCodes: ['J9'],
        stopoverAirportCodes: ['KWI'],
        allianceCodes: [''],
        stopoversCount: 1,
        departureTimeMinutes: 1005,
        arrivalTimeMinutes: 1350,
        departureDateTime: '2024-10-31T16:45:00.000+04:00',
        arrivalDateTime: '2024-10-31T22:30:00.000+03:00',
        stopoverDurationMinutes: 120,
        durationMinutes: 405,
        overnight: false,
        stopoverDuration: '02h',
        durationDays: 0,
        longStopover: false,
        segments: [
          {
            durationMinutes: 105,
            stopoverDurationMinutes: 120,
            departureAirportCode: 'DXB',
            arrivalAirportCode: 'KWI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9124',
            departureDateTime: '2024-10-31T16:45:00.000+04:00',
            arrivalDateTime: '2024-10-31T17:30:00.000+03:00',
            arrivalAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            departureAirport: {
              name: 'Dubai International Airport',
              code: 'DXB',
              cityCode: 'DXB',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
            operatingAirlineCode: '',
          },
          {
            durationMinutes: 180,
            stopoverDurationMinutes: 0,
            departureAirportCode: 'KWI',
            arrivalAirportCode: 'CAI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9733',
            departureDateTime: '2024-10-31T19:30:00.000+03:00',
            arrivalDateTime: '2024-10-31T22:30:00.000+03:00',
            arrivalAirport: {
              name: 'Cairo Airport',
              code: 'CAI',
              cityCode: 'CAI',
            },
            departureAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
            operatingAirlineCode: '',
          },
        ],
        operatingAirlineCodes: [],
        stopoverCode: 'ONE_STOP',
        shortStopover: false,
        earlyDeparture: false,
        lateArrival: false,
        newAircraft: false,
        oldAircraft: true,
        highlyRatedCarrier: false,
        score: 831,
        stops: [
          {
            code: 'ONE_STOP',
            price: {
              totalAmount: 738,
              totalAmountWithFraction: 738.0,
              totalAmountUsd: 738.2,
              amount: 738,
              amountWithFraction: 738.0,
              amountUsd: 738.2,
              originalAmount: 738.2,
              originalAmountUsd: 738.2,
              amountPerAdult: 738.2,
              amountPerChild: 0,
              amountPerInfant: 0,
              taxAmount: 347.2,
              taxAmountUsd: 347.2,
              totalTaxAmount: 347.2,
              totalTaxAmountUsd: 347.2,
              currencyCode: 'USD',
              paymentFeeAmountUsd: 0,
              bookingFee: 0,
              bookingFeeUsd: 0,
              totalBookingFee: 0,
              totalBookingFeeUsd: 0,
            },
          },
        ],
      },
      segmentViewModels: [
        {
          segment: {
            operatingAirlineCode: '',
            durationMinutes: 105,
            stopoverDurationMinutes: 120,
            departureAirportCode: 'DXB',
            arrivalAirportCode: 'KWI',
            airlineCode: 'J9',
            cabin: 'economy',
            designatorCode: 'J9124',
            departureDateTime: '2024-10-31T16:45:00.000+04:00',
            arrivalDateTime: '2024-10-31T17:30:00.000+03:00',
            arrivalAirport: {
              name: 'Kuwait Airport',
              code: 'KWI',
              cityCode: 'KWI',
            },
            departureAirport: {
              name: 'Dubai International Airport',
              code: 'DXB',
              cityCode: 'DXB',
            },
            airline: {
              name: 'Jazeera Airways',
              code: 'J9',
            },
          },
          pointStartPercentage: 25.925925925925924,
          pointWidthPercentage: 29.629629629629626,
        },
      ],
    },
  ],
  tripId: '2de43e388d3fdfb2msr:J9124~31~1645~1730-J9733~31~1930~2230',
  normalizedFlight: false,
  tripCardTags: ['best', 'cheapest'],
  sponsored: {
    brandingColor: '#ff0000',
    brandingHeader: 'Match Day Shuttle',
    partnerLogoUrl: 'http://example.com/logo.png',
    brandingDescription: '',
  },
};
